import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface HomeCardCountsDto {
  events: number;
  teams: number;
  questions: number;
  scheduling: number;
}

@Injectable({
  providedIn: 'root'
})
export class HomeCountsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/home/counts';

  getCounts(): Observable<HomeCardCountsDto> {
    return this.http.get<HomeCardCountsDto>(this.apiUrl);
  }
}
